// components/order-terminal

/* заявка на операцию с контейнером */
/* global DEBUG */
/* global Vue */

import template from './modal.jade'
import style    from './style.scss'
import Store    from 'Store'
import Input    from 'lib/CurrentInput'
import CntList  from 'components/cnt-list/component'

var name = 'order-terminal'
var pattern = /[^A-Z{4}0-9]/g

const store = new Store(name)

var url = {
  main: 'api/order-terminal',
  train: 'index/klientam/raschet-dostavki/zhd-tarifyi.html',
  auto: '/index/klientam/raschet-dostavki/avto-tarifyi.html',
}

Input(jQuery)

// парсим полученный список
function parseCites(data) {
  var cites = []
  for (var item in data.tarifs ) {
    var value = item
    var text = data.tarifs[item].to
    cites.push({text, value: text})
  }

  return cites
}

export default {

  name: name,
  template: template({style: style}),

  data: () => ({
    name: name,
    url: url.main,
    delivery: null,
    containers: null,
    show: true,
    blockForm: false,
    errors: [],
    options: {
      train: false,
      auto: false,
    },
    order: {},
    profile_phone:null,
  }),

  ready() {
    var order
    // привязываем паттерн к input
  /*  var input = document.querySelector('.' + style.input)
    $(input).currentInput({ pattern: pattern })*/
$("input[name*='owner_name']").val(store.$get('name_expeditor'))
    // создадим экзепляр cnt-list и запросим
    // с сервера контейнеры за последние 30 дней
    var cntList = new Vue(CntList)
    // кинем евент с датами
    cntList.$emit('dates:cnt-list', {
      name: 'cnt-list',
      date_at: (new Date()).setDate((new Date()).getDate() - 30) / 1000,
      date_to: (new Date().getTime()) / 1000,
    })
    this.$set('cntList', cntList.$data)
    this.$set('profile_phone',store.$get('phone'))
  },

  methods: {
    submit(e) {
      e.preventDefault()
      var formData = new FormData()
      var data = $(this.$$.form).serializeArray()
        if (this.file !== undefined){
            formData.append('file', this.file)
        }
      formData.append('name_expeditor', store.$get('name_expeditor') )
      formData.append('email', store.$get('email') )
      formData.append('phone', store.$get('phone') )
      $.each(data, function(i, field){
             formData.append(field.name, field.value.trim())
        })
      this.$set('data', formData)
      this.blockForm = true
      store.$save(this)
      this.order = {}
      this.errors = ''
    },

    // обрабатываем файл из формы
    // https://github.com/vuejs/Discussion/issues/24
    upload(e) {
      e.preventDefault()
      var file = this.$$.order.files[0]
      /*DEBUG && console.log(file)*/
      if (file.size > 5*1024*1024) {
        alert ('Размер вложения не должен превышать 5MB !')
      } else {
        this.$set('file', file)
      }
    },

    // добавим контейнер
    add() {
      this.containers.push({
        number: this.number,
        selected: true,
        handle: true,
      })
      this.$set('number', null)
    },
    // удалим контейнер
    remove(e) {
      var vm = e.targetVM
      // вручную добавленные контейнеры удаляем,
      // скаченные - оставляем в выбираемых контейнерах
      if (vm.handle) {
        this.containers.splice(vm.$index, 1)
      } else {
        vm.selected = false
      }
    },
    // при закрытии окна возвратимся по истории назад и сбросим форму
    onClick(e) {
      e.preventDefault()
      // this.blockForm = this.feedback = this.data = null
      this.$set('show', true)
      var from = this.$route.router._currentTransition.from.name || 'index'
      this.$route.router.go({ name: from })
        if (this.$get('blockForm')) {
            location.reload()
        }
    },
  },

  watch: {
    // при выборе типа доставки груза,
    // если еще не скачали данные, то скачаем
    delivery() {
      var delivery = this.delivery
      if ( !this.options[delivery] ) {
        this.$set('loader', '(загрузка...)' )
        $.ajax({
          url: url[delivery],
          dataType: 'json'
        })
          // при удачном запросе, распарсим города
          .done( response => {
            this.$set('loader', null)
            this.options[delivery] = parseCites(response)
          })
          .fail(hxr => {
            this.$set('loader', '(Ошибка: ' + hxr.message + ')' )
            //DEBUG && console.log('Ошибка: ', hxr.message)
          })
      }
    },
    // при получении данных о контейнерах отсортируем
    // контейнеры и создадим массив containers
    cntList: {
      handler() {
          var table = this.cntList.data.table
          if (table && table.cnt_number === undefined) {
              this.containers = table
                  .filter(item => !item.date_out)
                  .map(item => {
                     return {
                          number: item.number,
                          konos: item.konos,
                          selected: false,
                      }
                  })
          } else this.containers = []
      },
      deep: true,
    },
  },

  events: {
    // если все ок, скроем поля формы
    'fetchData:error': function() {
        //DEBUG && console.log('fetchData    error')
      this.$set('blockForm', false)
    },
    // если все ок, скроем поля формы
    'fetchData:ok': function() {
      this.$set('errors','')
      if (this.$get('data["errors"]') !== undefined){
        var arr = Object.keys(this.$get('data["errors"]')),
            arr1 = this.$get('data["errors"]'),
            message = 'Ошибка при обработке данных заявки!'
        arr.forEach(function(item, i, arr) {
          message +='<br />'+(++i)+ '. '+arr1[item]
        });
        this.$set('errors', message)
        this.$set('blockForm', false)
        this.$set('show', true)
      }else {
        this.$set('errors', '')
        this.$set('blockForm', true)
        this.$set('show', false)
      }
    },
  },

}



/** WEBPACK FOOTER **
 ** ./src/js/components/order-terminal/index.js
 **/